module.exports = __webpack_public_path__ + "img/ai-calculating-tomorrow@2x.7d837801.png";